import { useEffect, useState } from 'react';
import { fetchBlobUrl } from '../api';

// Cache în memorie: userId:versiune -> URL local al pozei
const cache = new Map<string, Promise<string | null>>();
let version = 0;
/** Apelat după schimbarea pozei, ca să se reîncarce peste tot. */
export function bumpAvatars() {
  version++;
  cache.clear();
}

function initials(name: string) {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]!.toUpperCase()).join('') || '?';
}

export function Avatar({ userId, name, hasAvatar, size = 32 }: { userId: number; name: string; hasAvatar: boolean; size?: number }) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    if (!hasAvatar) {
      setUrl(null);
      return;
    }
    const key = `${userId}:${version}`;
    if (!cache.has(key)) cache.set(key, fetchBlobUrl(`/users/${userId}/avatar`).catch(() => null));
    cache.get(key)!.then((u) => alive && setUrl(u));
    return () => {
      alive = false;
    };
  }, [userId, hasAvatar, version]);

  const style = { width: size, height: size, fontSize: Math.round(size * 0.4) };
  return url
    ? <img className="avatar" src={url} alt={name} style={style} />
    : <span className="avatar avatar-initials" style={style} aria-label={name}>{initials(name)}</span>;
}

/** Redimensionează și decupează pătrat o imagine aleasă de utilizator (JPEG 256×256). */
export async function resizeToSquare(file: File, size = 256): Promise<string> {
  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = () => reject(new Error('Fișierul nu este o imagine validă.'));
    i.src = URL.createObjectURL(file);
  });
  const side = Math.min(img.naturalWidth, img.naturalHeight);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d')!;
  ctx.drawImage(img, (img.naturalWidth - side) / 2, (img.naturalHeight - side) / 2, side, side, 0, 0, size, size);
  URL.revokeObjectURL(img.src);
  return canvas.toDataURL('image/jpeg', 0.85);
}
